// extracted by mini-css-extract-plugin
export default {"info":"account-details_info__21kfP","contact":"account-details_contact__oYs3e","actions":"account-details_actions__VQp0S"};